import { commonEnvironment } from './environment.common';
import { EnvironmentContract } from './environment.contract';

export const environment: EnvironmentContract = {
  ...commonEnvironment,
  secretKey: 'ENV_SECRET_KEY',
  ssoUrl: 'https://sso-dev.bancadigital.com.co',
  dynatraceScriptUrl: 'https://js-cdn.dynatrace.com/jstag/17b628055ae/bf64848bdm/fea75dc649a44b89_complete.js',
  firebaseConfig: {
    ...commonEnvironment.firebaseConfig,
    apiKey: 'ENV_FIREBASE_API_KEY'
  },
  apiServices: {
    apiUrl: '/api/v1',
    biocatchUrl: 'https://bcdn-god.we-stats.com/scripts/4bc932c8/e8a54f73.js',
  },
};
